
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./protocols.cjs.production.min.js')
} else {
  module.exports = require('./protocols.cjs.development.js')
}
